import Tag from '../Tag';

/**
 * ConsentManager.Tag.StyleTag
 *
 * @author Felix Kiesewetter <info@felixkiesewetter.de>
 * @lastModified 2024-11-28
 * @package felixkiesewetter-js/consentmanager
 * @since 5.0.0
 */
class StyleTag extends Tag
{

    /**
     * Opt-in tag
     *
     * @returns {Tag}
     */
    optIn()
    {
        this.getConsentManager().enableStyleTag(this.getName());
        return super.optIn();
    }

}

export default StyleTag;
